import React from 'react';

const HousebetsLogoIconV2 = ({
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "116",
    height: "18",
    viewBox: "0 0 116 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.823 2.345C13.823 2.29616 13.823 2.25952 13.823 2.21068C13.823 2.16183 13.823 2.12519 13.823 2.07635V0.330078H10.074V2.07635C10.074 2.12519 10.074 2.16183 10.074 2.21068C10.074 2.25952 10.074 2.29616 10.074 2.345V7.13198H4.00484V2.33279C4.00484 2.29616 4.00484 2.24731 4.00484 2.21068C4.00484 2.17404 4.00484 2.12519 4.00484 2.08856V0.330078H0.255859V2.08856C0.255859 2.12519 0.255859 2.17404 0.255859 2.21068C0.255859 2.24731 0.255859 2.29616 0.255859 2.33279V15.6679C0.255859 15.7046 0.255859 15.7534 0.255859 15.7901C0.255859 15.8267 0.255859 15.8755 0.255859 15.9122V17.6706H4.00484V15.9122C4.00484 15.8755 4.00484 15.8267 4.00484 15.7901C4.00484 15.7534 4.00484 15.7046 4.00484 15.6679V10.881L7.03334 9.00036L10.0618 10.8687V15.6557C10.0618 15.7046 10.0618 15.7412 10.0618 15.7901C10.0618 15.8389 10.0618 15.8755 10.0618 15.9244V17.6706H13.8108V15.9244C13.8108 15.8755 13.8108 15.8389 13.8108 15.7901C13.8108 15.7412 13.8108 15.7046 13.8108 15.6557V2.345H13.823Z",
      fill: "#02F7FD"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.809 4.67773C17.8647 4.67773 15.5078 7.09565 15.5078 11.1499C15.5078 15.2042 17.8647 17.6099 21.809 17.6099C25.7534 17.6099 28.098 15.192 28.098 11.1499C28.098 7.10786 25.7412 4.67773 21.809 4.67773ZM21.809 14.5326C20.1482 14.5326 19.2079 13.2992 19.2079 11.1499C19.2079 9.00067 20.1482 7.73065 21.809 7.73065C23.4698 7.73065 24.4223 8.97624 24.4223 11.1499C24.4223 13.3236 23.4698 14.5326 21.809 14.5326Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M40.9447 4.92188V17.3778H37.3178V15.4117H36.8294V15.4728C36.6462 16.4863 35.8768 17.3167 34.8999 17.5243C34.6068 17.5854 34.3015 17.6098 33.984 17.6098C31.3219 17.6098 29.7344 15.6804 29.7344 12.4443V4.92188H33.3612V12.2977C33.3612 13.1403 33.6055 14.5325 35.2174 14.5325C36.8294 14.5325 37.3178 13.47 37.3178 11.6139V4.92188H40.9447Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M53.6453 13.4091C53.6453 14.7035 53.1202 15.7781 52.1433 16.5108C51.1786 17.2313 49.7864 17.6099 48.1134 17.6099C44.6575 17.6099 42.5938 15.9735 42.5938 13.2259V12.9206H46.013V13.2259C46.013 14.789 47.3319 15.021 48.1134 15.021C48.895 15.021 50.1284 14.8623 50.1284 13.7632C50.1284 12.6642 49.1392 12.5909 47.5151 12.31C45.5612 11.9925 42.8868 11.5407 42.8868 8.57326C42.8868 5.60582 44.8407 4.67773 48.1134 4.67773C51.3862 4.67773 53.3278 6.25304 53.3278 8.87855V9.17163H49.9085V8.87855C49.9085 7.51084 48.9316 7.21776 48.1134 7.21776C47.2952 7.21776 46.4038 7.32767 46.4038 8.3046C46.4038 9.28153 47.3319 9.26932 48.8339 9.53798H48.8828C50.8977 9.90433 53.6453 10.3806 53.6453 13.4091Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M63.157 12.542L63.1082 12.7741C62.8395 13.9708 61.9603 14.6425 60.7025 14.6425C59.4447 14.6425 58.712 13.8975 58.3945 12.542L56.9291 12.2978V11.7971H66.6373V11.1499C66.6373 7.09565 64.4148 4.67773 60.7025 4.67773C56.9901 4.67773 54.7188 7.09565 54.7188 11.1499C54.7188 15.2042 56.9535 17.6099 60.7025 17.6099C64.4515 17.6099 66.1977 15.8392 66.6373 12.884L66.6862 12.542H63.157ZM58.3212 10.0631C58.6753 8.04816 59.811 7.62075 60.7025 7.62075C61.5939 7.62075 62.693 7.93825 63.0349 10.0631V10.1364C63.0471 10.1364 58.309 10.1364 58.309 10.1364V10.0631H58.3212Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M75.8446 4.67692C74.1716 4.67692 72.8528 5.36077 72.1079 6.59415L71.998 6.77733V0.390625H68.3711V17.3771H71.998V15.411H72.4986V15.472C72.633 16.2414 73.1092 16.8886 73.7809 17.1939C74.3914 17.4748 75.0753 17.6091 75.8446 17.6091C78.922 17.6091 80.7537 15.1912 80.7537 11.1491C80.7537 7.10704 78.922 4.67692 75.8446 4.67692ZM74.4403 14.5317C72.8406 14.5317 71.8392 13.2373 71.8392 11.1491C71.8392 9.06091 72.8406 7.72984 74.4403 7.72984C76.04 7.72984 77.0536 8.97543 77.0536 11.1491C77.0536 13.3228 76.1011 14.5317 74.4403 14.5317Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M90.3665 12.542L90.3176 12.7741C90.0368 13.9708 89.1575 14.6425 87.8997 14.6425C86.6419 14.6425 85.9214 13.8975 85.5917 12.542L83.7966 12.2978V11.7971H93.8346V11.1499C93.8346 7.09565 91.6121 4.67773 87.8997 4.67773C84.1874 4.67773 81.916 7.09565 81.916 11.1499C81.916 15.2042 84.1508 17.6099 87.8997 17.6099C91.6487 17.6099 93.395 15.8392 93.8346 12.884L93.8835 12.542H90.3665ZM85.5307 10.0631C85.8726 8.04816 87.0083 7.62075 87.8997 7.62075C88.7912 7.62075 89.9025 7.93825 90.2322 10.0631V10.1364C90.2444 10.1364 85.5185 10.1364 85.5185 10.1364V10.0631H85.5307Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M114.899 13.4091C114.899 14.7035 114.374 15.7781 113.385 16.5108C112.432 17.2313 111.04 17.6099 109.367 17.6099C105.911 17.6099 103.848 15.9735 103.848 13.2259V12.9206H107.267V13.2259C107.267 14.789 108.586 15.021 109.367 15.021C110.149 15.021 111.382 14.8623 111.382 13.7632C111.382 12.6642 110.393 12.5909 108.769 12.31C106.815 11.9925 104.141 11.5529 104.141 8.57326C104.141 5.59361 106.095 4.67773 109.367 4.67773C112.64 4.67773 114.57 6.25304 114.57 8.87855V9.17163H111.15V8.87855C111.15 7.51084 110.186 7.21776 109.367 7.21776C108.549 7.21776 107.658 7.32767 107.658 8.3046C107.658 9.28153 108.586 9.26932 110.088 9.53798H110.137C112.139 9.90433 114.899 10.3806 114.899 13.4091Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M98.3516 7.65624V8.15691L99.6582 8.40115V13.0782C99.6582 13.7376 99.9269 14.5314 101.185 14.5314C102.443 14.5314 102.21 14.3971 102.577 14.1895L103.029 13.933V16.9493L102.858 17.0348C102.113 17.3889 101.124 17.6087 100.232 17.6087C97.5945 17.6087 96.0314 16.0701 96.0314 13.4812V7.66845H94.3828V4.92082H96.0314V1.26953H99.6582V4.92082H103.236V7.66845H98.3516V7.65624Z",
      fill: "white"
    }
  )
);

export { HousebetsLogoIconV2 };
//# sourceMappingURL=HousebetsLogoIconV2.js.map
